import React from 'react';
import { useSelector } from 'react-redux';
import { DistrictType, SupervisionType } from '../../../../../enums';
import schoolImg from '../../../../../assets/school.svg';
import classes from './SchoolInfo.module.css';

const SchoolInfo = (dropClass) => {

    const { texts } = useSelector((state) => state.translate);
    const { school } = useSelector((state) => state.auth);

    return (
        <div className={`${classes.schoolInfo} ${dropClass}`}>
            <img className={classes.schoolImage} src={schoolImg} alt="school" />
            <div className={classes.textContainer}>
                {school?.name && <p className={classes.boldText}>{`${texts.school} ${school?.name}`}</p>}
                <div className={classes.subTextContainer}>
                    <p className={classes.text}>
                        {`${school?.id ? school?.id : ''} ${school?.supervisionId ? `, ${texts[SupervisionType[school?.supervisionId]]}` : ''}`}
                    </p>
                    <p className={classes.text}>
                        {`${school?.city ? school?.city : ''}${school?.districtId ? `, ${texts.district}  ${texts[DistrictType[school?.districtId]]}` : ''}`}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SchoolInfo;

